import { z } from "zod";

export const activitySortKeys = [
  "person",
  "signal",
  "when",
  "source",
  "activity",
  "processing",
] as const;
export const peopleSortKeys = ["person", "company", "location", "latest", "processing"] as const;
export const companySortKeys = ["name", "domain", "people", "created"] as const;
export const deliverySortKeys = [
  "record",
  "destination",
  "state",
  "status",
  "attempts",
  "created",
] as const;
export type SortQuery<Key extends string = string> = {
  sort?: Key;
  direction?: "asc" | "desc";
};
export function sortQuerySchema<const Keys extends readonly [string, ...string[]]>(keys: Keys) {
  return z.object({
    sort: z.enum(keys).optional(),
    direction: z.enum(["asc", "desc"]).optional(),
  });
}
// Page URLs can contain stale columns after navigation. API requests are validated strictly.
export function readSort<Key extends string>(
  keys: readonly Key[],
  query: { sort?: string; direction?: string },
): SortQuery<Key> {
  const sort = keys.find((key) => key === query.sort);
  return sort ? { sort, direction: query.direction === "desc" ? "desc" : "asc" } : {};
}
